import React from "react";
import { useForm } from "react-hook-form";

const ChangeConfirmationMethod = () => {
	const {
		register,
		handleSubmit,
		formState: { errors },
	} = useForm();

	const onSubmit = (data) => {
		// TODO: integrate with backend
		console.log(data);
	};

	return (
		<div className="min-h-screen flex justify-center bg-white">
			<div className="w-full max-w-md px-4 pt-8 text-center">
				<img
					src="/BUY%20iT%20Logo.png"
					alt="BUY iT logo"
					className="mx-auto h-[64px] w-[53px] object-contain"
				/>

				<h1 className="mt-4 text-xl font-semibold">Change confirmation method</h1>

				<form onSubmit={handleSubmit(onSubmit)} className="mt-6" noValidate>
					<div>
						<input
							id="email"
							type="email"
							placeholder="Email address"
							className="block w-full rounded-md border border-gray-300 px-3 py-2 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-[#19C463] focus:border-[#19C463]"
							aria-invalid={errors.email ? "true" : "false"}
							{...register("email", {
								required: "Email is required",
								pattern: {
									value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
									message: "Enter a valid email",
								},
							})}
						/>
						{errors.email && (
							<p className="mt-2 text-left text-sm text-red-600" role="alert">
								{errors.email.message}
							</p>
						)}
					</div>

					<button
						type="submit"
						className="mt-6 w-full rounded-md bg-[#19C463] py-3 text-sm font-medium text-white shadow-sm hover:bg-[#19C463] active:opacity-90 focus:outline-none focus:ring-2 focus:ring-[#19C463] focus:ring-offset-2"
					>
						Continue
					</button>
				</form>
			</div>
		</div>
	);
};

export default ChangeConfirmationMethod;
